import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { DebugPageComponent } from "./debug-page.component";

export const debugPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-debug-page", DebugPageComponent)
    .atUrl("/about/debug")
    .requiresLogin(false)
    .build();
